module.exports = __webpack_public_path__ + "static/img/k24_kt_01.ba061409.png";